module.exports = __webpack_public_path__ + "img/liftIcon5.0fcb4530.png";